// @flow
import { toastError } from 'bench-internal-theme';
import { Mutation } from '@apollo/client/react/components';
import React from 'react';

import type { ClientComment, InternalNote } from './types';
import {
  CREATE_LEDGER_ACCOUNT_INTERNAL_NOTE,
  DELETE_LEDGER_ACCOUNT_INTERNAL_NOTE,
  UPDATE_LEDGER_ACCOUNT_INTERNAL_NOTE,
  UPDATE_JOURNAL_ENTRY_INTERNAL_NOTE,
  CREATE_JOURNAL_ENTRY_INTERNAL_NOTE,
  DELETE_JOURNAL_ENTRY_INTERNAL_NOTE,
} from './queries';
import MessageList from './MessageList';
import messageListTypes from './messageListTypes';
// $FlowFixMe - TS file
import { getJournalEntries1099RefetchQuery } from '../transaction-manager/components/transactions-1099-container/graphql';

const parentTypeMutations = {
  // TODO Define these mutations as needed by https://benchco.atlassian.net/browse/IN-1812
  // [messageListTypes.JOURNAL_ENTRY_CLIENT_COMMENT]: {
  //   create: CREATE_JOURNAL_ENTRY_CLIENT_COMMENT,
  //   delete: DELETE_JOURNAL_ENTRY_CLIENT_COMMENT,
  //   update: UPDATE_JOURNAL_ENTRY_CLIENT_COMMENT,
  // },
  [messageListTypes.JOURNAL_ENTRY_INTERNAL_NOTE]: {
    create: CREATE_JOURNAL_ENTRY_INTERNAL_NOTE,
    delete: DELETE_JOURNAL_ENTRY_INTERNAL_NOTE,
    update: UPDATE_JOURNAL_ENTRY_INTERNAL_NOTE,
  },
  [messageListTypes.LEDGER_ACCOUNT_INTERNAL_NOTE]: {
    create: CREATE_LEDGER_ACCOUNT_INTERNAL_NOTE,
    delete: DELETE_LEDGER_ACCOUNT_INTERNAL_NOTE,
    update: UPDATE_LEDGER_ACCOUNT_INTERNAL_NOTE,
  },
};

const handleMutationError = error =>
  toastError(
    'Change Was Not Saved',
    `An error was encountered while trying to save. The error was: ${error.message}`,
  );

type MessageListContainerProps = {
  clientId?: string,
  listType: $Values<messageListTypes>,
  messages: Array<InternalNote | ClientComment>,
  parentId: string,
  placeholder?: string,
  zeroStateMessage?: string,
};

const MessageListContainer = ({
  clientId,
  listType,
  messages,
  parentId,
  placeholder,
  zeroStateMessage,
}: MessageListContainerProps) => {
  const mutationRefetchQuery = getJournalEntries1099RefetchQuery(clientId);
  return (
    <Mutation
      mutation={parentTypeMutations[listType].create}
      refetchQueries={mutationRefetchQuery}
      onError={handleMutationError}
    >
      {createMessage => (
        <Mutation
          mutation={parentTypeMutations[listType].delete}
          refetchQueries={mutationRefetchQuery}
          onError={handleMutationError}
        >
          {deleteMessage => (
            <Mutation
              mutation={parentTypeMutations[listType].update}
              refetchQueries={mutationRefetchQuery}
              onError={handleMutationError}
            >
              {updateMessage => (
                <MessageList
                  createMessage={body => createMessage({ variables: { parentId, body } })}
                  editMessage={(id, body) => updateMessage({ variables: { parentId, id, body } })}
                  deleteMessage={id => deleteMessage({ variables: { parentId, id } })}
                  flagMessage={(id, flagged) =>
                    updateMessage({ variables: { parentId, id, flagged } })
                  }
                  messages={messages}
                  placeholder={placeholder}
                  zeroStateMessage={zeroStateMessage}
                />
              )}
            </Mutation>
          )}
        </Mutation>
      )}
    </Mutation>
  );
};

MessageListContainer.defaultProps = {
  placeholder: undefined,
  zeroStateMessage: undefined,
};

export default MessageListContainer;
